import * as React from 'react';
import { USPList } from '@grandvisionhq/common';
import { LocationSearch } from '@grandvisionhq/locations';
import { useIntl } from '@grandvisionhq/state';
import { Components, useStoreFinderContext, Hooks } from '@grandvisionhq/stores-v2';
import { fromStoreResultToStore } from '../../pages/BookAppointment/adapters/from-store-result-to-store.js';
import '@swc/helpers';
import '@grandvisionhq/graphql';
import '@grandvisionhq/utils';
import '../../pages/BookAppointment/queries/get-book-appointment-store.js';
import '../../pages/BookAppointment/queries/get-book-appointment-type.js';
import useVirtualAppointment from '../../pages/BookAppointment/hooks/use-virtual-appointment.js';
import AppointmentInfoContainer from '../LinkedAppointmentInfo/LinkedAppointmentInfoContainer.js';
import SelectedChoicesContainer from '../SelectedChoices/SelectedChoicesContainer.js';
import HighlightPreferredStore from './HighlightPreferredStore/HighlightPreferredStoreContainer.js';
import NoStoresAlertContainer from './NoStoresAlert/NoStoresAlertContainer.js';
import StoreFinderItemContainer from './StoreFinderItem/StoreFinderItemContainer.js';
import StoreFinderMapContainer from './StoreFinderMap/StoreFinderMapContainer.js';
import StoreFinderSearchFormContainer from './StoreFinderSearchForm/StoreFinderSearchFormContainer.js';

const StoreListTopContent = Components.StoreListTopContent;
const StoreFinderContainer = ({ appointmentTypeId  })=>{
    const { getLabel , hasLabel  } = useIntl();
    const { isPristineSearch , isStoresLoading , stores , config  } = useStoreFinderContext();
    const { googleMapsId  } = config;
    const showTabs = Hooks.useTabs();
    const [{}, { enabled: isVirtualAppointmentEnabled  }] = useVirtualAppointment();
    const storeListTopContent = /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
        className: "appointments-store-finder__selected-choices"
    }, /*#__PURE__*/ React.createElement(SelectedChoicesContainer, null)), /*#__PURE__*/ React.createElement(AppointmentInfoContainer, {
        className: "appointments-store-finder__linked-appointment-type"
    }), /*#__PURE__*/ React.createElement(StoreListTopContent, {
        title: getLabel('appointments.component.storeFinder.title'),
        description: hasLabel('appointments.component.storeFinder.description') ? getLabel('appointments.component.storeFinder.description') : undefined
    }));
    const uspList = /*#__PURE__*/ React.createElement("div", {
        className: "appointments-store-finder__usp-list"
    }, /*#__PURE__*/ React.createElement(USPList, {
        usps: [
            'appointments.component.storeFinder.usp1',
            'appointments.component.storeFinder.usp2',
            'appointments.component.storeFinder.usp3', 
        ]
    }));
    const showNoStoresAlert = !isPristineSearch && !isStoresLoading && stores.length === 0;
    const showUSPs = !isVirtualAppointmentEnabled && !isStoresLoading && stores.length === 0;
    const storeListInfoContent = /*#__PURE__*/ React.createElement(React.Fragment, null, showNoStoresAlert ? /*#__PURE__*/ React.createElement("div", {
        className: "appointments-store-finder__info-content"
    }, /*#__PURE__*/ React.createElement(NoStoresAlertContainer, null)) : null, showUSPs ? uspList : null);
    return /*#__PURE__*/ React.createElement(LocationSearch, {
        className: "appointments-store-finder",
        googleMapsId: googleMapsId,
        showTabs: showTabs,
        searchForm: /*#__PURE__*/ React.createElement(StoreFinderSearchFormContainer, {
            appointmentTypeId: appointmentTypeId
        }),
        listTopContent: storeListTopContent,
        listInfoContent: storeListInfoContent,
        loadingListItems: isStoresLoading,
        listItems: stores.length ? stores.map((store)=>/*#__PURE__*/ React.createElement(StoreFinderItemContainer, {
                key: store.code,
                variant: "list-item",
                store: fromStoreResultToStore(store),
                "data-t": "searchResults"
            })
        ) : [],
        mapContent: /*#__PURE__*/ React.createElement(StoreFinderMapContainer, {
            stores: stores,
            googleMapsId: googleMapsId
        }),
        highlightPreferredStore: /*#__PURE__*/ React.createElement(HighlightPreferredStore, {
            applicableAppointmentTypeId: appointmentTypeId
        })
    });
};

export { StoreFinderContainer as default };
//# sourceMappingURL=StoreFinderContainer.js.map
